import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import QueryDialog from '../../../components/QueryDialog';
import dataModel from '../../../models/DataModel';
import './SystemPopupView.scss';

// Change SystemPopupView to the appropriate name
export class SystemPopupView extends BaseComponent {

  constructor(props) {
    super(props);
    this.handleWidth = 100;
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    if (this.dialog) {
      this.dialog.setAttribute('tabIndex', Math.ceil(Math.random() * 100));
      this.dialog.focus();
    }
  }

  componentWillUnmount() {
  }

  updateWindowDimensions() {
    this.setState({ viewWidth: window.innerWidth, viewHeight: window.innerHeight });
  }

  handleCancelClick(e) {
    this.props.dataModel.systemPopup = null;
    this.props.dataModel.hideGlobalModal();

    let { handleOwnerCancel } = this.props.systemPopup ? this.props.systemPopup.props : this.props;
    if (handleOwnerCancel != undefined) {
      handleOwnerCancel();
    }
  }

  handleOkClick(e) {
    this.props.dataModel.systemPopup = null;
    this.props.dataModel.hideGlobalModal();

    let { handleOwnerOk } = this.props.systemPopup ? this.props.systemPopup.props : this.props;
    if (handleOwnerOk) {
      handleOwnerOk(e);
    }
  }

  handleKeyDown(e) {
    if (e.keyCode == 27) {
      this.handleCancelClick(e);
    }
    else if (e.keyCode == 13 || e.keyCode == 40) {
      this.handleOkClick(e);
    }
  }

  render() {
    let { message } =this.props.systemPopup ? this.props.systemPopup.props : this.props;

    let messageWithBreaks = [];
    if (message && message.split) {
      messageWithBreaks = message.split('\n').length > 1 ? message.split('\n').map((string, index) => {
        return (
          <span key={index}>
            {string}
            <br/>
          </span>
        );
      }): message;
    }
    else {
      messageWithBreaks = message;
    }

    const content =
      <div className="system-popup-view">
          <div className={message ? 'system-popup-message' : ''}>
            { messageWithBreaks }
          </div>
        </div>;

    const popupContents = {
      popupId: 'globalPopup',
      height: this.props.height,
      width: this.props.width || 320,
      content: content,
      captionText: this.props.captionText ? this.props.captionText : 'WARNING',
      handleOwnerOk: this.handleOkClick,
      handleOwnerCancel: this.handleCancelClick,
      currentUser: this.props.currentUser,
      cancelButtonText: this.props.cancelButtonText ? this.props.cancelButtonText : 'Cancel',
      okButtonText: this.props.okButtonText ? this.props.okButtonText : 'Ok',
      okButtonColor: this.props.okButtonColor,
      oneButton: this.props.oneButton,
      short: true,
      type: this.props.type ? this.props.type : 'warning',
      useInput: this.props.useInput,
    };
    return (
      <div ref={(element) => {
        this.dialog = element;
      }} onKeyDown={this.handleKeyDown}>
        <QueryDialog queryDialog={popupContents} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    systemPopup: state.main.systemPopup,
    currentCompany: state.new_companies.currentCompany,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SystemPopupView);



// WEBPACK FOOTER //
// ./src/components/modals/SystemPopupView/index.js